module.exports = __webpack_public_path__ + "static/media/backyard.7f85a1b4.png";